// src/context/PortalThemeContext.js — Light/dark theme state for the partner
// portal only. Persisted per-browser in localStorage; defaults to 'dark' so
// nothing changes for anyone until they opt in. The internal CRM does not
// use this context and has no light mode.
import { createContext, useContext, useState } from 'react'

const THEME_KEY = 'rga_portal_theme'

const PortalThemeContext = createContext(null)

export function PortalThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem(THEME_KEY) === 'light' ? 'light' : 'dark' }
    catch { return 'dark' }
  })

  function toggleTheme() {
    setTheme(t => {
      const next = t === 'light' ? 'dark' : 'light'
      try { localStorage.setItem(THEME_KEY, next) } catch {}
      return next
    })
  }

  return (
    <PortalThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </PortalThemeContext.Provider>
  )
}

export function usePortalTheme() {
  return useContext(PortalThemeContext)
}
